import { useContext, useEffect, useState } from "react";
import { I18nContext } from "../../I18nProvider";
import { Box, CircularProgress, Container, Grid } from "@mui/material";
import { PieChart } from "@mui/x-charts/PieChart/PieChart";
import IresearhService from "../../services/IresearchService";
import { PubGender } from "../../Interface/IPubGender";
import { PubAnual } from "../../Interface/IPubAnual";
import { BarChart } from "@mui/x-charts/BarChart/BarChart";
import { CitAnual } from "../../Interface/ICitAnuales";


export const Estadisticas: React.FC<{}> = () => {
    const context = useContext(I18nContext);
    const [loadingGender, setLoadingGender] = useState<boolean>(true); 
    const [pubGender, setPubGender] = useState<PubGender>();
    const [pubAnuales, setpubAnuales] = useState<PubAnual[]>([]);
    const [loadingPubAnual, setLoadingPubAnual] = useState<boolean>(true);
    const xAxisData = pubAnuales.map((item) => item.anio); 
    const seriesData = pubAnuales.map((item) => item.publicaciones); 
    const [citAnuales, setcitAnuales] = useState<CitAnual[]>([]);
    const [loadingCitAnual, setLoadingCitAnual] = useState<boolean>(true);
    const xAxisDataCit = citAnuales.map((item) => item.anio); 
    const seriesDataCit = citAnuales.map((item) => item.citaciones);



	if (context === null) {
		throw new Error(
			"The I18n context is not initialized. Make sure you have the provider set up correctly."
		);
	}

    useEffect(() => {
        IresearhService.GetAuthorCountByGender()
            .then((pubGenderData) => {
                
                const pubGenderDataRecib = pubGenderData.data
                setPubGender(pubGenderDataRecib)
            })
            .catch((error) => {
                console.error("Error fetching user data from backend:", error);
            })
            .finally(() => {
                setLoadingGender(false); 
            });


        IresearhService.GetInstitutionPublicationsByYear()
            .then((pubAnual) => {
                const pubAnualesList = pubAnual.data.lista_publicaciones
                const sortedPubAnuales = pubAnualesList.sort(
                    (a: { anio: number }, b: { anio: number }) => a.anio - b.anio
                );
                setpubAnuales(sortedPubAnuales)
            })
            .catch((error) => {
                console.error("Error fetching user data from backend:", error);
            })
            .finally(() => {
                setLoadingPubAnual(false); 
          });

        

        IresearhService.GetEspolCitationsByYear()
            .then((citAnual) => {
                
                const pubAnualesList = citAnual.data.lista_citaciones
                const sortedPubAnuales = pubAnualesList.sort(
                    (a: { anio: number }, b: { anio: number }) => a.anio - b.anio
                );
                setcitAnuales(sortedPubAnuales)
            })
            .catch((error) => {
                console.error("Error fetching user data from backend:", error);
            })
            .finally(() => {
                setLoadingCitAnual(false); 
            });


    }, []);



	return (
		<Container>
			<h1>{context.t.translate("home.estadisticas")}</h1>
            <Grid container justifyContent="center" spacing={4} alignItems="center">

                <Grid item xs={12} sm={6} md={6} sx={{ padding: "20px" }}>
                    <h4>{context.t.translate("estadisticas.citAnuales")}</h4>

                    {loadingCitAnual ? ( 
                        <Box display="flex" justifyContent="center" alignItems="center" height="60vh">
                            <CircularProgress />
                        </Box>
                    ) : (
                            <BarChart
                                xAxis={[
                                    {
                                        id: 'anios',
                                        data: xAxisDataCit,
                                        scaleType: 'band',
                                    },
                                ]}
                                series={[
                                    {
                                        data: seriesDataCit,
                                    },
                                ]}
                                width={500}
                                height={300}
                            />
                    )}
                </Grid>
                <Grid item xs={12} sm={6} md={6} sx={{ padding: "20px" }}>
                    <h4>{context.t.translate("estadisticas.pubAnuales")}</h4>

                    {loadingPubAnual ? ( 
                        <Box display="flex" justifyContent="center" alignItems="center" height="60vh">
                            <CircularProgress />
                        </Box>
                    ) : (
                        <BarChart
                            xAxis={[
                                {
                                    id: 'anios',
                                    data: xAxisData,
                                    scaleType: 'band',
                                },
                            ]}
                            series={[
                                {
                                    data: seriesData,
                                },
                            ]}
                            width={500}
                            height={300}
                        />
                    )}
                </Grid>



                <Grid item xs={12} sm={6} md={6} sx={{ padding: "20px" }}>
                    <h4>{context.t.translate("estadisticas.investigadores")}</h4>
              
                    {loadingGender ? ( 
                        <Box display="flex" justifyContent="center" alignItems="center" height="60vh">
                            <CircularProgress />
                        </Box>
                    ) : (
                        <PieChart
                            series={[
                            
                                    {
                                        data: pubGender
                                            ? [
                                                { id: 0, value: pubGender.hombres, label: context.t.translate("estadisticas.hombres")  },
                                                { id: 1, value: pubGender.mujeres, label: context.t.translate("estadisticas.mujeres"), color: "#B800D8"  },
                                            ]
                                            : [], 
                                    },
                            
                            ]}
                            width={400}
                            height={200}
                        />
                    )}
                </Grid>
            </Grid>
		</Container>
	)
}



